document.addEventListener('DOMContentLoaded', handleResize);

let previousWidth = window.innerWidth; // Przechowuje poprzednią szerokość okna
window.addEventListener('resize', function () {
    if (window.innerWidth !== previousWidth) {
        previousWidth = window.innerWidth;
        handleResize();
    }
});

function handleResize() {
    const sections = document.querySelectorAll('.heading-text--dropdown');

    sections.forEach(section => {
        const toggleButton = section.querySelector('.heading-text__toggle');
        const wysiwyg = section.querySelector('.heading-text__wysiwyg');
        
        // Sprawdź, czy pierwszym elementem wewnątrz wysiwyg jest <p>
        const firstElement = wysiwyg.firstElementChild;
        if (firstElement.tagName.toLowerCase() !== 'p') {
            return; // Nie uruchamiaj skryptu, jeśli pierwszym elementem nie jest <p>
        }

        const lineHeight = parseFloat(getComputedStyle(wysiwyg).lineHeight);
        const maxHeight = lineHeight * 5; // Maksymalna wysokość dla 5 pełnych linijek tekstu
        
        // Sprawdź wysokość pierwszego elementu <p>
        const pHeight = firstElement.scrollHeight;

        // Ustaw wysokość na podstawie wysokości <p>
        let heightToSet;
        if (pHeight > maxHeight) {
            heightToSet = maxHeight; // Jeśli wysokość <p> jest większa niż 5 linijek
        } else {
            heightToSet = pHeight; // Jeśli wysokość <p> jest mniejsza niż 5 linijek
        }

        // Jeśli tekst nie jest rozwinięty, ustawiamy odpowiednią wysokość
        if (!wysiwyg.classList.contains('expanded')) {
            wysiwyg.style.maxHeight = heightToSet + 'px';
        }

        // Pokazuj lub ukrywaj przycisk "Rozwiń/Zwiń" w zależności od tego, czy tekst faktycznie przekracza wysokość
        if (wysiwyg.scrollHeight > heightToSet) {
            toggleButton.style.display = 'inline-block'; // Pokaż przycisk, jeśli tekst przekracza wysokość
        } else {
            toggleButton.style.display = 'none'; // Ukryj przycisk, jeśli tekst mieści się w wysokości
        }

        // Upewnij się, że event listener na kliknięcie jest przypisany tylko raz
        if (!toggleButton.classList.contains('listener-added')) {
            toggleButton.addEventListener('click', function () {
                if (wysiwyg.classList.contains('expanded')) {
                    wysiwyg.style.maxHeight = heightToSet + 'px';
                    toggleButton.textContent = wysiwyg.getAttribute('data-show') || 'Rozwiń';
                } else {
                    wysiwyg.style.maxHeight = wysiwyg.scrollHeight + 'px';
                    toggleButton.textContent = wysiwyg.getAttribute('data-hide') || 'Zwiń';
                }
                wysiwyg.classList.toggle('expanded');
            });

            toggleButton.classList.add('listener-added'); // Oznacz przycisk jako obsłużony
        }
    });
}
